import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC, ReactNode } from 'react'

const WhiteBoxContainer: FC<{ children: ReactNode; sx?: SxProps }> = ({ children, sx }) => {
    return (
        <Box
            sx={{
                backgroundColor: `Surface100`,
                borderRadius: '12px',
                ...sx,
            }}
        >
            {children}
        </Box>
    )
}

export default WhiteBoxContainer
